import { createSelector } from '@reduxjs/toolkit';
import { selectSubsidizedMortgageValue } from './selectSubsidizedMortgageValue';
import {
  SUBSIDIZED_MORTGAGE_ENABLED_KEY,
  SUBSIDIZED_MORTGAGE_EXCLUDED_REGIONS_KEY,
  SUBSIDIZED_MORTGAGE_LABEL_TEXT_KEY,
} from 'shared/constants/subsidizedMortgage';
import { selectRegionId } from 'shared/selectors/location';
import { IConfig } from '@cian/config/shared';

export const selectSubsidizedMortgageFilter = (config: IConfig) =>
  createSelector([selectSubsidizedMortgageValue, selectRegionId], (value, regionId) => {
    const isSubsidizedMortgageEnabled = Boolean(config.get<boolean>(SUBSIDIZED_MORTGAGE_ENABLED_KEY));
    const excludedRegions = config.get<number[]>(SUBSIDIZED_MORTGAGE_EXCLUDED_REGIONS_KEY) || [];
    const optionLabel = config.get<string>(SUBSIDIZED_MORTGAGE_LABEL_TEXT_KEY) || '';

    return {
      label: 'Ипотечные предложения',
      value: [value],
      visible: isSubsidizedMortgageEnabled && optionLabel && !excludedRegions.includes(regionId),
      options: [
        { label: 'Неважно', value: null },
        { label: optionLabel, value: true },
      ],
    };
  });
